import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Award, FileText, Settings, BarChart3, ArrowLeft } from 'lucide-react';
import { CertificateTemplateManager } from '@/components/certificates/CertificateTemplateManager';
import { CourseAssignments } from '@/components/certificates/CourseAssignments';
import { IssuedCertificates } from '@/components/certificates/IssuedCertificates';
import { CertificateReports } from '@/components/certificates/CertificateReports';
import { useNavigate } from 'react-router-dom';

export default function CertificateManagement() {
  const [activeTab, setActiveTab] = useState('templates');
  const navigate = useNavigate();

  return (
    <div className="container mx-auto py-8 px-4">
      <div className="mb-8">
        <div className="flex items-center gap-4 mb-4">
          <Button 
            variant="ghost" 
            onClick={() => navigate('/admin-dashboard')}
            className="hover-scale"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Dashboard
          </Button>
        </div>
        <h1 className="text-3xl font-bold flex items-center gap-2">
          <Award className="h-8 w-8 text-primary" />
          Certificate Management
        </h1>
        <p className="text-muted-foreground mt-2">
          Create, customize, and manage certificates for course completions.
        </p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="templates" className="flex items-center gap-2">
            <FileText className="h-4 w-4" />
            Templates
          </TabsTrigger>
          <TabsTrigger value="assignments" className="flex items-center gap-2">
            <Settings className="h-4 w-4" />
            Course Assignments
          </TabsTrigger>
          <TabsTrigger value="issued" className="flex items-center gap-2">
            <Award className="h-4 w-4" />
            Issued Certificates
          </TabsTrigger>
          <TabsTrigger value="reports" className="flex items-center gap-2">
            <BarChart3 className="h-4 w-4" />
            Reports
          </TabsTrigger>
        </TabsList>

        <TabsContent value="templates">
          <Card>
            <CardHeader>
              <CardTitle>Certificate Templates</CardTitle>
            </CardHeader>
            <CardContent>
              <CertificateTemplateManager />
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="assignments">
          <Card>
            <CardHeader>
              <CardTitle>Course Certificate Assignments</CardTitle>
            </CardHeader>
            <CardContent>
              <CourseAssignments />
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="issued">
          <Card>
            <CardHeader>
              <CardTitle>Issued Certificates</CardTitle>
            </CardHeader>
            <CardContent>
              <IssuedCertificates />
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="reports">
          <Card>
            <CardHeader>
              <CardTitle>Certificate Reports & Analytics</CardTitle>
            </CardHeader>
            <CardContent>
              <CertificateReports />
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
}